import React, { useCallback, useEffect, useState } from 'react';

import { useMyUserId } from '../../../../data/hooks/sessionHooks';
import FavoriteIcon from '../../../elements/icons/FavoriteIcon/FavoriteIcon';
import Link from '../../../elements/Link';


const TopBarFavoriteParticipant = props => {
    const {event, user} = props,
        myUserId = useMyUserId(),
        [favorited, setFavorited] = useState(user.is_favorite);

    useEffect(() => {
        if (user.is_favorite != favorited) setFavorited(user.is_favorite);
    }, [user]);

    const handleToggleFavorite = useCallback(() => {
        setFavorited(!favorited);
        app.api.participants.toggleFavorite(user, !favorited, event?.id);
    }, [user, event, favorited]);

    if (!user) return null;
    if (user.user_id == myUserId) return null;

    return (
        <Link onClick={handleToggleFavorite}>
            <FavoriteIcon active={favorited} />
        </Link>
    );
};

export default TopBarFavoriteParticipant;
